export const refs = {
  todoInput: document.querySelector('.todo-input'),
  todoCounter: document.querySelector('.todo-counter'),
  clearCompletedBtn: document.querySelector('.todo-list-button'),
  filtersList: document.querySelector('.filters-list'),
  creationWrapper: document.querySelector('.creation-wrapper'),
  filtersWrapper: document.querySelector('.filters-wrapper'),
  todoWrapper: document.querySelector('.todo-wrapper'),
  todoList: document.querySelector('.todo-list'),
  themeBtn: document.querySelector('.theme-button'),
  backgroundImg: document.querySelector('#bg-img'),
};
